import React from 'react';
import { ModalType } from '../../../types/modals';

import GroupCloseModal from './GroupCloseModal';
import GroupChangeFounderModal from './GroupChangeFounderModal';

import InviteToGroupModal from './InviteToGroupModal';
import ReportProfileModal from '../ReportProfile/ReportProfileModal';

export const modalRenderer = (
  modalType: string,
  requestClose: () => void,
  params?: any
) => {
  switch (modalType) {
    case ModalType.REPORT_PROFILE:
      return (
        <ReportProfileModal
          requestClose={requestClose}
          userId={params.userId}
        />
      );

    case ModalType.GROUP_CLOSE:
      return <GroupCloseModal requestClose={requestClose} />;

    case ModalType.GROUP_CHANGE_FOUNDER:
      return <GroupChangeFounderModal requestClose={requestClose} />;

    case ModalType.INVITE_TO_GROUP:
      return (
        <InviteToGroupModal requestClose={requestClose} group={params.group} />
      );
    default:
      return;
  }
};

export default modalRenderer;
